export const environment = {
  production: false,
  // Configuration for MSAL (Microsoft Authentication Library)
  AUTH_CONFIG: {
    clientId: 'aff75fe9-3b69-4648-a8d6-eb1a57634a9a',
    authority:
      'https://login.microsoftonline.com/8d88c9c2-2058-486d-9cd4-2fc9010326bc/v2.0',
    redirectUri: 'https://tciudev.ingredion.com',
    postLogoutRedirectUri: 'https://tciudev.ingredion.com',
    scopes: ['user.read'],
    tciu_scope: ['api://85627d41-1b45-4e01-b365-093140655407/access_as_user'],
  },
  // Configuration for the API
  API_CONFIG: {
    uri: 'https://graph.microsoft.com/v1.0/me',
    tciu_scope: ['api://85627d41-1b45-4e01-b365-093140655407/access_as_user'],
  },
  APP_BASE_URL: 'https://tciudev.ingredion.com/api',
  AG_GRID_K: '6247047890123456',
  AG_GRID_K_IV: '6543210987624704',
};
